import PropTypes from 'prop-types';
import React from 'react';
import { kebabCase } from 'lodash';
const ControlSwitchControl = ({
  control,
  children,
  onClick
}) => {
  const handleClick = () => onClick(control);
  const className = `t-csc-${kebabCase(control.name)}`;
  return /*#__PURE__*/React.createElement("div", {
    role: "link",
    tabIndex: 0,
    className: `control-switch-control t-csc-control-switch-control ${className}`,
    onKeyPress: handleClick,
    onClick: handleClick
  }, children);
};
ControlSwitchControl.propTypes = {
  control: PropTypes.shape({
    id: PropTypes.string,
    control: PropTypes.node,
    name: PropTypes.string
  }).isRequired,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired
};
export default ControlSwitchControl;